import countries from "i18n-iso-countries";

import * as items from "i18n-iso-countries/langs/en.json";
import {
  geocodeByAddress,
  getLatLng,
  geocodeByPlaceId,
} from "react-places-autocomplete";

countries.registerLocale(items);

// For creating a location search value manually
export function getLocationValue(address) {
  let val = address?.StreetNumber ?? "";

  if (address?.StreetNumber) {
    val = address.StreetNumber;
    val += " ";
  }

  if (address?.Address1) {
    val += address.Address1;

    if (address?.Address2) {
      val += " ";
    }
  }

  val += address?.Address2 ?? "";

  if (address?.Address1 || address?.Address2) {
    val += ", ";
  }

  if (address?.City) {
    val += address?.City;
    val += ", ";
  }

  if (address?.StateProvince) {
    val += address.StateProvince;

    if (address?.ZipCode) {
      val += " ";
    }
  }

  if (address?.ZipCode) {
    val += address.ZipCode;
  }

  if (address?.StateProvince || address?.ZipCode) {
    val += ", ";
  }

  if (address?.Country) {
    val += address.Country;
  }

  return val;
}

export async function handleLocationSelection(value, byID = false) {
  const newLocation = {
    Readable: "",
    Address: {
      Address1: "",
      Address2: "",
      StreetNumber: "",
      City: "",
      StateProvince: "",
      ZipCode: "",
      Country: "",
      CountryCode2: "",
      CountryCode3: "",
    },
    Geo: {
      lat: null,
      lng: null,
    },
  };

  let geoCode;

  if (byID) {
    geoCode = await geocodeByPlaceId(value);
  } else {
    geoCode = await geocodeByAddress(value);
  }

  const latLng = await getLatLng(geoCode[0]);

  const formattedAddress = geoCode[0].formatted_address;

  newLocation.Readable = formattedAddress;
  newLocation.Geo = latLng;

  for (const component of geoCode[0].address_components) {
    for (const type of component.types) {
      if (type === "street_number") {
        const streetNumber = component.long_name;

        newLocation.Address.StreetNumber = streetNumber;
        continue;
      }
      if (type === "route") {
        const address1 = component.long_name;

        newLocation.Address.Address1 = address1;
        continue;
      }
      if (type === "subpremise") {
        const address2 = component.long_name;

        newLocation.Address.Address2 = address2;
        continue;
      }
      if (type === "locality") {
        const city = component.long_name;

        newLocation.Address.City = city;
        continue;
      }
      if (type === "administrative_area_level_1") {
        const stateProvince = component.long_name;

        newLocation.Address.StateProvince = stateProvince;
        continue;
      }
      if (type === "country") {
        const country = component.long_name;
        const countryAlphaCode2 = countries.getAlpha2Code(country, "en");
        const countryAlphaCode3 = countries.getAlpha3Code(country, "en");

        newLocation.Address.Country = country;
        newLocation.Address.CountryCode2 = countryAlphaCode2;
        newLocation.Address.CountryCode3 = countryAlphaCode3;

        continue;
      }
      if (type === "postal_code") {
        const postalCode = component.long_name;

        newLocation.Address.ZipCode = postalCode;
        continue;
      }
    }
  }

  return newLocation;
}
